import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase.js'

/**
 * Live points + activities for a single participant.
 */
export function usePoints(participantId) {
  const [state, setState] = useState({ points: 0, activities: [], events: [], status: 'loading' })

  useEffect(() => {
    if (!supabase || !participantId) {
      setState({ points: 0, activities: [], events: [], status: 'ready' })
      return
    }

    let cancelled = false

    async function reload() {
      const [activitiesRes, eventsRes] = await Promise.all([
        supabase
          .from('activities')
          .select('*, post_stats(*)')
          .eq('participant_id', participantId)
          .order('created_at', { ascending: false }),
        supabase
          .from('point_events')
          .select('*')
          .eq('participant_id', participantId)
          .order('created_at', { ascending: false }),
      ])
      if (cancelled) return
      const events = eventsRes.data || []
      const points = events.reduce((s, e) => s + e.points, 0)
      setState({
        points,
        activities: activitiesRes.data || [],
        events,
        status: 'ready',
      })
    }

    reload()

    const channel = supabase
      .channel(`participant-${participantId}-${Math.random().toString(36).slice(2, 10)}`)
      .on('postgres_changes',
        { event: '*', schema: 'public', table: 'point_events', filter: `participant_id=eq.${participantId}` },
        reload)
      .on('postgres_changes',
        { event: '*', schema: 'public', table: 'activities', filter: `participant_id=eq.${participantId}` },
        reload)
      .subscribe()

    return () => {
      cancelled = true
      supabase.removeChannel(channel)
    }
  }, [participantId])

  return state
}
